import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getVouchers: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    const vouchers = await api.get("vouchers");
    await store.update((state) => {
      state.vouchers = vouchers;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const updateVoucher: EvokeAction<AppState, AppActions> = async (
  store,
  values: object
) => {
  try {
    await api.patch(`vouchers/status`, {}, values);
  } catch (error) {
    throw error;
  }
};

export const voucherActions = {
  getVouchers,
  updateVoucher,
};
